import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63589923"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register-bg-pattern" }, null, -1))
const _hoisted_3 = { class: "register-container fade-in" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logotipo",
    src: "/logo-white.png",
    alt: "logo"
  })
], -1))
const _hoisted_5 = { class: "register-card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Criar conta"),
  /*#__PURE__*/_createElementVNode("p", null, "Registe-se para começar a usar o Goldylocks")
], -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Email", -1))
const _hoisted_9 = { class: "control has-icons-left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" })
], -1))
const _hoisted_11 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Senha", -1))
const _hoisted_14 = { class: "control has-icons-left has-icons-right" }
const _hoisted_15 = ["type"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1))
const _hoisted_17 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_18 = { class: "field mt-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Confirmação senha", -1))
const _hoisted_20 = { class: "control has-icons-left" }
const _hoisted_21 = ["type"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" })
], -1))
const _hoisted_23 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-plus mr-2" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Criar conta ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "register-footer" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left mr-2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Já tem conta? Entre aqui ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordForceCheck = _resolveComponent("PasswordForceCheck")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", {'is-danger':_ctx.alreadyExistantEmail}]),
                type: "email",
                placeholder: "ex. cliente@exemplo.com",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                required: ""
              }, null, 2), [
                [_vModelText, _ctx.email]
              ]),
              _hoisted_10
            ]),
            (_ctx.alreadyExistantEmail)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Email já registado!"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", {'is-danger':_ctx.canCheckPasswords && !_ctx.enoughPasswordChars, 'is-success': _ctx.enoughPasswordChars}]),
                type: _ctx.showPassword ? 'text' : 'password',
                placeholder: "********",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                required: ""
              }, null, 10, _hoisted_15), [
                [_vModelDynamic, _ctx.password]
              ]),
              _hoisted_16,
              _createElementVNode("span", {
                class: "icon is-small is-right password-toggle",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.showPassword ? 'fas fa-eye-slash' : 'fas fa-eye')
                }, null, 2)
              ])
            ]),
            (!_ctx.enoughPasswordChars && _ctx.passwordChars > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, " A senha tem de conter no mínimo 8 caracteres "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_PasswordForceCheck, { password: _ctx.password }, null, 8, ["password"]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", {'is-danger':_ctx.canCheckPasswords && !_ctx.samePassword}]),
                type: _ctx.showConfirmPassword ? 'text' : 'password',
                placeholder: "********",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
                required: ""
              }, null, 10, _hoisted_21), [
                [_vModelDynamic, _ctx.passwordConfirmation]
              ]),
              _hoisted_22
            ]),
            (_ctx.canCheckPasswords && !_ctx.samePassword)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, " As senhas não coincidem! "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            disabled: !_ctx.enoughPasswordChars || !_ctx.samePassword,
            class: _normalizeClass(["button is-primary is-fullwidth mt-5", {'is-loading':_ctx.isLoading}])
          }, _hoisted_27, 10, _hoisted_24)
        ], 32),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_router_link, { to: "/login" }, {
            default: _withCtx(() => [
              _hoisted_29,
              _hoisted_30
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}